import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

export const useGetGeneratorsById = (generatorIds: string[]) => {
  const { data: generators, isFetching: isFetchingGenerators } = useQuery(
    ['generators-by-id', generatorIds.join('-')],
    async () => {
      const generators = await backendService.instance.generators.listByIds(generatorIds);
      return generators;
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    generators,
    isFetchingGenerators,
  };
};
